import { FC } from "react";
import { Snowflake } from "lucide-react";
// Light icy tint with a faint noise texture; the card stays readable.
export const FrostOverlay: FC = () => (
  <div className="pointer-events-none absolute inset-0 z-[15]">
    <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(186,230,253,0.38)_0%,rgba(255,255,255,0.14)_55%,rgba(186,230,253,0.28)_100%)]" />
    <img
      className="absolute inset-0 h-full w-full object-cover opacity-20 mix-blend-overlay"
      src="/images/card-noise.webp"
      alt=""
    />
  </div>
);

// Only frozen cards carry a badge; cancelled ones are shown blurred.
export const FrozenBadge: FC = () => (
  <span className="pointer-events-none absolute top-3 left-3 z-20 flex items-center gap-1 rounded-full border border-[#BAE6FD]/60 bg-[#0C4A6E]/50 px-2 py-0.5 text-[10px] font-medium text-[#E0F2FE] backdrop-blur-sm">
    <Snowflake className="size-3" strokeWidth={1.75} />
    Frozen
  </span>
);
